import { IEntityLookupData } from '../models';
import { rootApi } from '../../../../services/rootApi';

const lookupAttributeDataApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getLookupAttributeData: builder.query<IEntityLookupData[], { siteId: string, attributeId: string }>({
      query: ({ siteId, attributeId }) => `/LookupAttributeData/Attribute(${siteId},${attributeId})`,
    }),

    getLookupAttributeName: builder.query<IEntityLookupData, { siteId: string, attributeId: string, valueId: string }>({
      query: ({ siteId, attributeId, valueId }) => `/LookupAttributeData/AttributeName(${siteId},${attributeId},${valueId})`,
    }),
  })
})

export const {
  useGetLookupAttributeDataQuery,
  useLazyGetLookupAttributeDataQuery,
  useLazyGetLookupAttributeNameQuery,
} = lookupAttributeDataApi;